import { lazy } from 'react';

const PayCreate = lazy(() => import(/* webpackChunkName: "PayCreate" */ './create/index'));
const PayList = lazy(() => import(/* webpackChunkName: "PayList" */ './list/index'));

export default [
  {
    name: 'pay.create',
    path: '/create/pay',
    exact: true,
    isPublic: false,
    layout: {
      header: true,
      footer: false,
      sidebar: true,
    },
    component: PayCreate,
    routeScopes: ['crud_user_invoices'],
  },
  {
    name: 'pay.list',
    path: '/list/pay',
    exact: true,
    isPublic: false,
    layout: {
      header: true,
      footer: false,
      sidebar: true,
    },
    component: PayList,
    routeScopes: ['crud_user_invoices'],
  },
];